import React, {useState} from "react";
import DatePicker from "react-datepicker";
import TodayIcon from '@mui/icons-material/Today';
import {TextField, InputAdornment} from '@mui/material';

const MuiDatePicker = (props) => {
  const {
    defaultLabel,
    defaultValue,
    dateFormat,
    fieldName,
    onChange,
    maxDateOption = false,
    required = false,
    fullWidth = false,
    activityId = null
  } = props;

    const [selectedDate, setSelectedDate] = useState(
        defaultValue !== undefined ? defaultValue : new Date() // Set default to today if no defaultValue
    );
    const [touched, setTouched] = useState(false); // Track if the field has been focused
    const today = new Date();

    const handleDateChange = (date) => {
        setSelectedDate(date);
        if (onChange) {
            onChange(fieldName, date);
        }
    };

    const handleBlur = () => {
        setTouched(true); // Mark the field as touched when it loses focus
    };

    const showError = required && touched && !selectedDate; // Show error if required, touched, and no date

  return (
    <div className="customDatePickerWrapper" style={{ width: fullWidth ? '100%' : '', display: 'block' }}>
      <DatePicker
        selected={selectedDate}
        onChange={handleDateChange}
        onBlur={handleBlur} // Add onBlur handler
        customInput={
          <TextField
            variant="outlined"
            fullWidth
            required={required}
            label={`${defaultLabel}${required ? '*' : ''}`}
            error={showError} // Set the error prop based on showError
            helperText={showError ? 'Dette feltet er påkrevd' : (activityId==="act19" ? '' : ' ')} // Display error message
            sx={{
              '& label': {
                color: '#3F4949',
                fontFamily: 'Inter'
              },
              '& label.Mui-focused': {
                color: '#00696D',
                fontFamily: 'Inter'
              }
            }}
            InputProps={{
              style: {
                height: "56px",
                paddingRight: 0,
              },
              endAdornment: (
                <InputAdornment position="end" style={{ margin: 0 }}>
                  <TodayIcon sx={{ marginRight: '8px', color: '#3F4949' }} />
                </InputAdornment>
              ),
            }}
          />
        }
        dateFormat={dateFormat}
        maxDate={maxDateOption ? today : ''}
      />
    </div>
  );
};

export default MuiDatePicker;
